const formatImpact = (funds, devider) => Math.ceil((funds / devider) * 25);

export default formatImpact;
